var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext, useState } from "react";
import { ValidSortDirections, } from "../components/Table/Table";
import { NameColoredCircle } from "../components/Table/NameColoredCircle";
import { doNothing } from "../components/Table/NameColoredCircle/NameColoredCircle";
import { ScoreFormatter } from "../pages/AssessmentPage/AssessmentPage";
import { getColorDecider } from "./action";
import { bubbleBackgroundColor } from "./cohortHelpers";
import { ScoreColorFormatting } from "../components/Table/ScoreColorFormatting/ScoreColorFormatting";
import { FilterContext } from "../providers/FilterProvider";
import { useGetDataCustomFiltersQuery, useGetProjects, useGetSingleAvailableCohortReportsQuery, } from "../store/api/core";
export var percentileScore = {
    header: "Percentile Score",
    defaultSortDirection: ValidSortDirections.ASC,
    formatter: ScoreFormatter,
    valueTransformer: function (row) { return ({
        sort: row.percentile,
        data: {
            score: "".concat(row.percentile, "%"),
        },
    }); },
};
export var getScoreLevelDescription = function (header, getValue) { return ({
    header: header,
    defaultSortDirection: ValidSortDirections.ASC,
    formatter: ScoreFormatter,
    valueTransformer: function (row) { return ({
        sort: getValue(row.score_level || 0),
        data: {
            score: getValue(row.score_level || 0),
        },
    }); },
}); };
export var getScoreDescription = function (header, getValue) { return ({
    header: header,
    defaultSortDirection: ValidSortDirections.ASC,
    formatter: ScoreFormatter,
    valueTransformer: function (row) {
        var _a, _b;
        return ({
            sort: getValue(((_a = row.score) === null || _a === void 0 ? void 0 : _a.toFixed(1)) || 0),
            data: {
                score: getValue(((_b = row.score) === null || _b === void 0 ? void 0 : _b.toFixed(1)) || 0),
            },
        });
    },
}); };
export var getColoredScore = function (header, colors, valueTransformer, showPercent) {
    if (showPercent === void 0) { showPercent = false; }
    return ({
        header: header,
        defaultSortDirection: ValidSortDirections.ASC,
        formatter: function (_a) {
            var data = _a.data;
            return (_jsx(ScoreColorFormatting, { showPercent: showPercent, data: data, getColor: getColorDecider(colors) }));
        },
        valueTransformer: valueTransformer,
    });
};
/* eslint-disable @typescript-eslint/no-explicit-any */
export var getNameDefinitionValueTransformer = function (getBottom, getRoleName) {
    return function (row) {
        var _a, _b, _c, _d;
        return ({
            sort: "".concat((_b = (_a = row === null || row === void 0 ? void 0 : row.firstName) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : "", " ").concat((_d = (_c = row === null || row === void 0 ? void 0 : row.lastName) === null || _c === void 0 ? void 0 : _c.toLowerCase()) !== null && _d !== void 0 ? _d : ""),
            data: {
                firstName: row.firstName,
                lastName: row.lastName,
                roleName: (getRoleName !== null && getRoleName !== void 0 ? getRoleName : getBottom)(row),
                belowNameAttribute: getBottom(row),
            },
        });
    };
};
/* eslint-enable @typescript-eslint/no-explicit-any */
export var nameDefinition = {
    header: "Name",
    defaultSortDirection: ValidSortDirections.ASC,
    formatter: function (_a) {
        var data = _a.data;
        return (_jsx(NameColoredCircle, { onClick: doNothing, data: data, backgroundColor: bubbleBackgroundColor }));
    },
    isHighlighted: true,
    defaultSortOrderKey: "name",
    valueTransformer: getNameDefinitionValueTransformer(function (row) { return (row === null || row === void 0 ? void 0 : row.belowNameAttribute) || ""; }, function (row) { return (row === null || row === void 0 ? void 0 : row.jobTitle) || ""; }),
};
export var targetScoreColumnHeader = {
    header: "Target Score",
    defaultSortDirection: ValidSortDirections.ASC,
    formatter: ScoreFormatter,
    valueTransformer: function (row) { return ({
        sort: row.target,
        data: {
            score: row.target,
        },
    }); },
};
export var scoreDifferenceColumnHeader = {
    header: "Score Difference",
    defaultSortDirection: ValidSortDirections.ASC,
    formatter: ScoreFormatter,
    valueTransformer: function (row) {
        return {
            sort: row.scoreDiff,
            data: {
                score: "".concat(row.scoreDiff > 0 ? "+".concat(row.scoreDiff) : row.scoreDiff),
            },
        };
    },
};
export var LabelFromFilterValue = function (_a) {
    var _b, _c, _d;
    var value = _a.value, className = _a.className;
    var allFilters = useContext(FilterContext).getFilters;
    var filters = useGetDataCustomFiltersQuery({ filters: allFilters() });
    return (_jsx("span", __assign({ className: className || "" }, { children: ((_d = (_c = (_b = filters === null || filters === void 0 ? void 0 : filters.data) === null || _b === void 0 ? void 0 : _b.indexed) === null || _c === void 0 ? void 0 : _c[value]) === null || _d === void 0 ? void 0 : _d.label) || "" })));
};
export var getDynamicColumnHeader = function (attribute) { return ({
    header: _jsx(LabelFromFilterValue, { value: attribute }),
    defaultSortDirection: ValidSortDirections.ASC,
    formatter: ScoreFormatter,
    valueTransformer: function (row) {
        var _a, _b;
        return ({
            // row[attribute] is a rendered element (CustomText), so sort by the raw value instead
            sort: ((_b = (_a = row["".concat(attribute, "Raw")]) !== null && _a !== void 0 ? _a : row[attribute]) !== null && _b !== void 0 ? _b : "")
                .toString()
                .toLowerCase(),
            data: {
                score: row[attribute],
            },
        });
    },
}); };
export var ProjectNameText = function (_a) {
    var _b, _c;
    var id = _a.id;
    var _d = useState(""), missingMessage = _d[0], setMissingMessage = _d[1];
    var projects = useGetProjects({});
    var project = (_c = (_b = projects === null || projects === void 0 ? void 0 : projects.data) === null || _b === void 0 ? void 0 : _b.indexed) === null || _c === void 0 ? void 0 : _c[id];
    setTimeout(function () {
        if (missingMessage != "") {
            return;
        }
        setMissingMessage("Missing Project Name");
    }, 5000);
    return (project === null || project === void 0 ? void 0 : project.name) || missingMessage;
};
var attributeKeys = [
    "column1Attribute",
    "column2Attribute",
    "belowNameAttribute",
];
/* eslint-disable @typescript-eslint/no-explicit-any */
var CustomText = function (_a) {
    var attribute = _a.attribute, mapping = _a.mapping, leader = _a.leader;
    return mapping == "project" ? (_jsx(ProjectNameText, { id: (leader === null || leader === void 0 ? void 0 : leader[attribute]) || "" })) : attribute === "belowNameAttribute" ? ((leader === null || leader === void 0 ? void 0 : leader[attribute]) || "") : ((leader === null || leader === void 0 ? void 0 : leader[attribute]) || "-");
};
/* eslint-enable @typescript-eslint/no-explicit-any */
export var useColumnedTableReportDataWithKnown = function (_a, options) {
    var _b, _c, _d, _e;
    var useTableData = _a.useTableData, reportId = _a.reportId, skillGroup = _a.skillGroup, skill = _a.skill, category = _a.category, assessmentCategory = _a.assessmentCategory, column1Attribute = _a.column1Attribute, column2Attribute = _a.column2Attribute, belowNameAttribute = _a.belowNameAttribute;
    var getFilters = useContext(FilterContext).getFilters;
    var attributeMap = {
        column1Attribute: column1Attribute,
        column2Attribute: column2Attribute,
        belowNameAttribute: belowNameAttribute,
    };
    var endpointReturn = useTableData({
        filters: __assign(__assign({}, getFilters()), { column1Attribute: column1Attribute, column2Attribute: column2Attribute, belowNameAttribute: belowNameAttribute }),
        column1: column1Attribute,
        column2: column2Attribute,
        belowName: belowNameAttribute,
        category: category,
        assessmentCategory: assessmentCategory,
        skillGroup: skillGroup,
        skill: skill,
        reportId: reportId,
    }, options);
    var skillGroupLevel = ((_c = (_b = endpointReturn === null || endpointReturn === void 0 ? void 0 : endpointReturn.data) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.leaders_at_skillgroup_level) || [];
    var skillLevel = ((_e = (_d = endpointReturn === null || endpointReturn === void 0 ? void 0 : endpointReturn.data) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.leaders_at_skill_level) || [];
    var data = (skillGroupLevel.length > 0 ? skillGroupLevel : skillLevel).map(function (leader) { return (__assign(__assign({}, leader), attributeKeys.reduce(function (acc, key) {
        var _a;
        var _b;
        return (__assign(__assign({}, acc), (_a = {}, _a[attributeMap[key] || "undefined"] = (_jsx(CustomText, { attribute: key, mapping: attributeMap[key], leader: leader })), _a["".concat(attributeMap[key], "Raw")] = (_b = leader === null || leader === void 0 ? void 0 : leader[key]) !== null && _b !== void 0 ? _b : "", _a[key] = (_jsx(CustomText, { attribute: key, mapping: attributeMap[key], leader: leader })), _a)));
    }, {}))); });
    return data;
};
export var useColumnedTableReportData = function (_a, options) {
    var _b, _c, _d, _e, _f, _g;
    var useTableData = _a.useTableData, reportId = _a.reportId, skillGroup = _a.skillGroup, skill = _a.skill, category = _a.category;
    var report = useGetSingleAvailableCohortReportsQuery({
        reportId: reportId || "",
    }, { shouldSkipCall: function () { return !reportId; } });
    var column1Attribute = (_c = (_b = report === null || report === void 0 ? void 0 : report.data) === null || _b === void 0 ? void 0 : _b.leaderTableOptions) === null || _c === void 0 ? void 0 : _c.column1Attribute;
    var column2Attribute = (_e = (_d = report === null || report === void 0 ? void 0 : report.data) === null || _d === void 0 ? void 0 : _d.leaderTableOptions) === null || _e === void 0 ? void 0 : _e.column2Attribute;
    var belowNameAttribute = (_g = (_f = report === null || report === void 0 ? void 0 : report.data) === null || _f === void 0 ? void 0 : _f.leaderTableOptions) === null || _g === void 0 ? void 0 : _g.belowNameAttribute;
    var data = useColumnedTableReportDataWithKnown({
        useTableData: useTableData,
        reportId: reportId,
        skillGroup: skillGroup,
        skill: skill,
        category: category,
        assessmentCategory: category,
        column1Attribute: column1Attribute,
        column2Attribute: column2Attribute,
        belowNameAttribute: belowNameAttribute,
    }, options);
    return data;
};
